<div class="reports-container">
  <div class="page-header">
    <h2>Membership Reports</h2>
    <p class="muted">Aggregate metrics across all active packages, options, and features.</p>
  </div>

  @if (summaryResource.value(); as summary) {
    <section class="summary-section">
      <div class="summary-header">
        <h3>Packages Overview</h3>
        <div class="summary-actions">
          <small class="muted">Generated {{ formatDateTime(summary.generatedAt) }}</small>
          <p-button
            icon="pi pi-refresh"
            severity="secondary"
            pTooltip="Refresh summary"
            tooltipPosition="top"
            [text]="true"
            [rounded]="true"
            [loading]="summaryResource.isLoading()"
            (onClick)="refreshSummary()"
          ></p-button>
        </div>
      </div>

      <div class="summary-totals">
        <div class="summary-stat">
          <span class="stat-label">Active Packages</span>
          <span class="stat-value">{{ summary.totalActivePackages }}</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">Active Subscribers</span>
          <span class="stat-value">{{ summary.totalActiveSubscribers }}</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">Committed (Active + Pending)</span>
          <span class="stat-value">{{ summary.totalCommittedSubscribers }}</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">Pending Memberships</span>
          <span class="stat-value">{{ summary.totalPendingMemberships }}</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">Cancelled Memberships</span>
          <span class="stat-value">{{ summary.totalCancelledMemberships }}</span>
        </div>
      </div>

      @if (summary.productLines && summary.productLines.length > 0) {
        <div class="product-lines">
          @for (line of summary.productLines; track line.productLine) {
            <div class="product-line-card">
              <div class="product-line-header">
                <strong>{{ line.productLine }}</strong>
                <span class="muted">{{ line.packageCount }} package{{ line.packageCount === 1 ? '' : 's' }}</span>
              </div>
              <div class="product-line-stats">
                <span><strong>{{ line.activeSubscribers }}</strong> active</span>
                <span><strong>{{ line.pendingMemberships }}</strong> pending</span>
                <span><strong>{{ line.committedSubscribers }}</strong> committed</span>
              </div>
              @if (line.packages && line.packages.length > 0) {
                <ul class="product-line-packages">
                  @for (pkg of line.packages; track pkg.packageId) {
                    <li>
                      <span class="pkg-name" [pTooltip]="pkg.packageCode || ''" tooltipPosition="top">
                        {{ pkg.name }}
                      </span>
                      <span class="pkg-counts">
                        <span class="pill active">{{ pkg.activeMemberships }} active</span>
                        <span class="pill pending">{{ pkg.pendingMemberships }} pending</span>
                        <span class="pill cancelled">{{ pkg.cancelledMemberships }} cancelled</span>
                      </span>
                    </li>
                  }
                </ul>
              }
            </div>
          }
        </div>
      }
    </section>
  } @else if (summaryResource.isLoading()) {
    <div class="summary-loading">
      <p-progressSpinner [style]="{ width: '32px', height: '32px' }"></p-progressSpinner>
      <small>Loading summary…</small>
    </div>
  } @else if (summaryResource.error()) {
    <div class="summary-error">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Failed to load summary.</span>
      <p-button label="Retry" severity="secondary" [text]="true" (onClick)="refreshSummary()"></p-button>
    </div>
  }
</div>
